module.exports = __webpack_public_path__ + "img/multiTank_s_new.6736c249.jpg";